// 受検日From
import { atom } from "recoil";
import { AtomKeys } from "../recoilKeys";

// 受検日FromのAtom（データストア）
export const dateFromState = atom<Date | null>({
    key: AtomKeys.DATE_FROM_STATE,
    default: null,
});
